import React from "react";

// A short row of mutually exclusive choices, shown inline so one tap changes the filter.
export default function SegmentedFilter({ label, value, options, onChange }) {
    return (
        <div className="flex items-center gap-2">
            <span id={`seg-${label}`} className="font-Mulish text-xs font-medium uppercase tracking-wide text-graphite">{label}</span>
            <div
                role="radiogroup"
                aria-labelledby={`seg-${label}`}
                className="inline-flex items-center rounded-full bg-white p-0.5 shadow-[0_0_0_1px_var(--hairline)]"
            >
                {options.map((option) => {
                    const selected = option.value === value;
                    return (
                        <button
                            key={option.value}
                            type="button"
                            role="radio"
                            aria-checked={selected}
                            onClick={() => onChange(option.value)}
                            className={`rounded-full px-3.5 py-1.5 font-Mulish text-sm transition-colors ${
                                selected
                                    ? "bg-primary-100 font-semibold text-primary-700 ring-1 ring-inset ring-primary-200"
                                    : "text-graphite hover:bg-hover-tint hover:text-secondary"
                            }`}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
